import { Link } from "react-router-dom";
import { ArrowRight, UtensilsCrossed } from "lucide-react";
import { QrMedia } from "../public/qr/QrMedia";
import { OfferCarousel } from "./OfferCarousel";
import { ItemCard } from "./ItemCards";
import { SiteFooter } from "./SiteFooter";

const PREVIEW_PER_CATEGORY = 4;

/** Homepage: banner → Our Menu tiles → 2×2 category previews → Recommended → Explore Full Menu → Brand Wall → smart footer. */
export const Home = ({ slug, site, branch, menu, ctrl, qtyOf, onBanner, sheetsOpen }) => {
  const cats = menu.categories || [];
  const items = menu.items || [];
  const recommended = (menu.recommended_item_ids || []).map((id) => items.find((i) => i.id === id)).filter((i) => i && i.is_available);
  return (
    <>
      {menu.banners?.length > 0 && <div data-testid="home-banner"><OfferCarousel banners={menu.banners} onOpen={onBanner} paused={sheetsOpen} /></div>}

      {cats.length > 0 && (
        <section className="os-section" data-testid="home-our-menu">
          <div className="os-section-head"><h2>Our Menu</h2><Link to={`/order/${slug}/menu`} className="os-link" data-testid="home-view-full-menu">Full menu <ArrowRight size={14} /></Link></div>
          <nav className="os-cat-tiles" aria-label="Menu categories">
            {cats.map((c) => (
              <Link key={c.id} to={`/order/${slug}/menu/${c.id}`} className="os-cat-tile" data-testid={`home-category-${c.id}`}>
                <QrMedia src={c.image_url} alt={c.name} /><span>{c.name}</span>
              </Link>
            ))}
          </nav>
        </section>
      )}

      {cats.map((c) => {
        const preview = items.filter((i) => i.category_id === c.id && i.is_available).slice(0, PREVIEW_PER_CATEGORY);
        if (!preview.length) return null;
        return (
          <section className="os-section" key={c.id} data-testid={`home-preview-${c.id}`}>
            <div className="os-section-head"><h2 style={{ fontSize: 17 }}>{c.name}</h2><Link to={`/order/${slug}/menu/${c.id}`} className="os-link" data-testid={`home-preview-all-${c.id}`}>View all <ArrowRight size={14} /></Link></div>
            <div className="os-grid2">{preview.map((it) => <ItemCard key={it.id} it={it} qty={qtyOf[it.id] || 0} ctrl={ctrl} testPrefix="home-item" />)}</div>
          </section>
        );
      })}

      {recommended.length > 0 && (
        <section className="os-section" data-testid="home-recommended">
          <div className="os-section-head"><div><h2>Recommended for you</h2><p>Hand-picked by {branch?.name}</p></div></div>
          <div className="os-grid2">{recommended.map((it) => <ItemCard key={it.id} it={it} qty={qtyOf[it.id] || 0} ctrl={ctrl} testPrefix="rec-item" />)}</div>
        </section>
      )}

      <section className="os-section">
        <Link to={`/order/${slug}/menu`} className="os-cta" data-testid="home-explore-menu"><UtensilsCrossed size={18} />Explore Full Menu <ArrowRight size={18} /></Link>
      </section>

      {menu.brand_wall_published && (
        <section className="os-section" data-testid="home-brand-wall">
          <Link to={`/order/${slug}/wall`} className="os-wall-tile" data-testid="home-brand-wall-link">
            <div><h3>Explore our Brand Wall</h3><p>The story, process and people behind {branch?.name}</p></div>
            <span className="os-arrow"><ArrowRight size={18} /></span>
          </Link>
        </section>
      )}

      <SiteFooter brand={site.brand} branch={branch} website={menu.website} />
    </>
  );
};
